var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0754 7.56757H9.44025V1.93243C9.44025 1.40541 9.01457 1 8.50781 1C8.00106 1 7.57538 1.42568 7.57538 1.93243V7.56757H1.94025C1.41322 7.56757 1.00781 7.99324 1.00781 8.5C1.00781 9.00676 1.43349 9.43243 1.94025 9.43243H7.57538V15.0676C7.57538 15.5946 8.00106 16 8.50781 16C9.01457 16 9.44025 15.5743 9.44025 15.0676V9.43243H15.0754C15.6024 9.43243 16.0078 9.00676 16.0078 8.5C16.0078 7.97297 15.6024 7.56757 15.0754 7.56757Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlack);
export default __webpack_public_path__ + "static/media/plus-black.3c9875afc4ab673342d1a6839412a837.svg";
export { ForwardRef as ReactComponent };